import { Check, EyeOff } from "lucide-react";
import { Reveal, Eyebrow } from "../components/Reveal";
import { TRUST_URL } from "../lib/constants";

export const Pricing = () => (
  <section className="bg-parchment py-24 sm:py-36" data-testid="pricing-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal className="max-w-3xl">
        <Eyebrow>Pricing</Eyebrow>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-ink tracking-tight leading-[1.06] mt-6">
          Good Trust or Great Trust. <em className="text-goldeep italic">There Is a Difference.</em>
        </h2>
        <p className="text-ink/70 text-base sm:text-lg leading-relaxed mt-6">
          Most people do not know this but not all trusts are created equal. Here is what separates a trust
          that protects you from a trust that makes you completely invisible.
        </p>
      </Reveal>

      <div className="grid md:grid-cols-2 gap-6 lg:gap-8 mt-14 sm:mt-20 max-w-5xl mx-auto">
        <Reveal delay={0.1} className="h-full">
          <div className="h-full bg-white border border-ink/10 rounded-3xl p-8 sm:p-12 shadow-sm hover:shadow-xl hover:-translate-y-1.5 transition-[box-shadow,transform] duration-500 flex flex-col" data-testid="pricing-basic-card">
            <p className="text-xs tracking-[0.28em] uppercase font-semibold text-ink/50">Basic Trust</p>
            <p className="font-display text-5xl sm:text-6xl text-ink mt-5">$1,497<span className="text-lg text-ink/40">.</span></p>
            <div className="h-px bg-ink/10 my-8" />
            <p className="text-ink/70 leading-relaxed flex-1">
              Your trust is legally valid and your assets are fully protected. Probate is avoided. Your family
              is covered. This is where most people start and it is solid protection. It is on public record.
              Someone who knows where to look can find it.
            </p>
            <a href={TRUST_URL} data-testid="pricing-basic-btn" className="mt-10 inline-flex justify-center items-center gap-2 border-2 border-ink text-ink font-bold text-sm tracking-[0.1em] uppercase px-8 py-4 rounded-full hover:bg-ink hover:text-cream transition-colors duration-300">
              <Check size={16} /> Get Started
            </a>
          </div>
        </Reveal>

        <Reveal delay={0.22} className="h-full">
          <div className="relative h-full bg-ink text-cream rounded-3xl p-8 sm:p-12 shadow-2xl border border-gold/40 hover:-translate-y-1.5 transition-transform duration-500 flex flex-col overflow-hidden" data-testid="pricing-private-card">
            <div className="absolute -top-20 -right-20 w-60 h-60 bg-gold/15 blur-3xl rounded-full" aria-hidden="true" />
            <span className="absolute top-6 right-6 bg-gold text-ink text-[10px] font-bold tracking-[0.2em] uppercase px-4 py-1.5 rounded-full">Recommended</span>
            <p className="text-xs tracking-[0.28em] uppercase font-semibold text-gold">Private Trust</p>
            <p className="font-display text-5xl sm:text-6xl text-cream mt-5">$2,497<span className="text-lg text-cream/40">.</span></p>
            <div className="h-px bg-gold/25 my-8" />
            <p className="text-cream/75 leading-relaxed flex-1">
              Your trust is completely invisible to the outside world. No public record. No one can search your
              name and find what you own. Your assets are protected and untraceable. This is what wealthy
              families actually use. Own everything. Appear to own nothing.
            </p>
            <a href={TRUST_URL} data-testid="pricing-private-btn" className="mt-10 inline-flex justify-center items-center gap-2 bg-gold text-ink font-bold text-sm tracking-[0.1em] uppercase px-8 py-4 rounded-full hover:bg-goldlight transition-colors duration-300 shadow-[0_0_35px_rgba(201,162,60,0.35)]">
              <EyeOff size={16} /> Get Started
            </a>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.15} className="text-center mt-12 max-w-2xl mx-auto">
        <p className="text-ink/80 font-medium text-base sm:text-lg">
          Start at $1,497 now. Upgrade to private for $1,000 more when you are ready.
        </p>
        <p className="font-display italic text-goldeep text-lg sm:text-xl mt-3">
          Both protect you. Only one makes you invisible. Ask about going private when we speak.
        </p>
      </Reveal>
    </div>
  </section>
);
